import React from 'react';
import PropTypes from 'prop-types';
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Box,
  Typography,
} from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { classes } from './utils';
import { lightPalette } from '../../../../theme';
import { globalClasses } from '../../utils/globalUtils';

const InputOutputApplications = ({
  title,
  list,
  isExpanded,
  isFlowRunning,
}) => {
  const sidebarWidth = 240;
  const collapsedWidth = 30;
  return (
    <Accordion defaultExpanded className={classes.accordion}>
      {isExpanded && (
        <AccordionSummary
          expandIcon={isExpanded ? <ExpandMoreIcon /> : null}
          className={classes.accordionExpanded}
        >
          <Typography variant="h5" color={lightPalette.darkPurple.main}>
            {title}
          </Typography>
        </AccordionSummary>
      )}
      <AccordionDetails>
        <Box
          className={classes.accordionExpanded}
          width={isExpanded ? sidebarWidth : collapsedWidth}
        >
          {Object.keys(list).map((type) => (
            <Box
              key={type}
              className={`${classes.accordionBox} ${isFlowRunning ? globalClasses.cursorDisabledClass : classes.cursorMove}`}
              draggable={!isFlowRunning}
              onDragStart={(e) => {
                e.dataTransfer.setData('type', type);
              }}
            >
              {list[type]}
              {isExpanded && (
                <Typography
                  variant="body1"
                  ml={2}
                  color={lightPalette.darkPurple.main}
                  fontWeight={400}
                >
                  {type}
                </Typography>
              )}
            </Box>
          ))}
        </Box>
      </AccordionDetails>
    </Accordion>
  );
};

InputOutputApplications.propTypes = {
  title: PropTypes.string.isRequired,
  list: PropTypes.node.isRequired,
  isExpanded: PropTypes.bool.isRequired,
  isFlowRunning: PropTypes.bool.isRequired,
};

export default InputOutputApplications;
